import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=a4ad6166&scoped=true"
import script from "./ActivityForm.vue?vue&type=script&lang=js"
export * from "./ActivityForm.vue?vue&type=script&lang=js"
import style0 from "./ActivityForm.vue?vue&type=style&index=0&id=a4ad6166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ad6166",
  null
  
)

export default component.exports